import request from '@/utils/request'


// 修改手机号码
export function changePhone(data) {
  return request({
    url: '/contractorinfo/changePhone',
    method: 'put',
    data: data
  })
}

// 更换手机号时校验身份证号(接包方和发包方共用)
export function idNumber(data) {
  return request({
    url: '/contractorinfo/verify/idNumber',
    method: 'post',
    data: data
  })
}

// 获取用户身份信息
export function getUserTypeInfo() {
  return request({
    url: '/userType/info/',
    method: 'get'
  })
}

// 提交 支付宝 充值金额
export function getalipayTrade(id) {
  return request({
    url: '/recharge/alipayTrade?rechargeAmount=' + id,
    method: 'get'
  })
}

// 更新现金劵弹框状态（不需要传参）
export function updatePopBox() {
  return request({
    url: '/contractorinfo/updatePopBox',
    method: 'put',
  })
}

// 押金充值-支付宝
export function getalipayTradeNotify(query) {
  return request({
    url: "/deposit/alipay",
    method: "get",
    params: query,
  });
}

// 押金充值-微信
export function getWechatTradeNotify(query) {
  return request({
    url: "/deposit/weChatPay",
    method: "get",
    params: query,
  });
}


// WEBPACK FOOTER //
// ./src/api/public/editphone.js